// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"43213":"ff83f6d840ab898f","92888":"c162294670d78af3"}[chunkId] + ".css";
};